"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.create.title': 'Crear Tutorial',
    'tutorial.create.button': 'Crear Tutorial',
};
